import type { PersonTimelineRow } from "./types";

export function getTimelineObjectId(row: PersonTimelineRow) {
  return row.id.split(":").slice(1).join(":") || row.id;
}
